module.exports = __webpack_public_path__ + "static/img/wan-fo-shen-xiang-you.0dd834f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/wan-fo-shen-xiang-you.jpg
// module id = fXWN
// module chunks = 1